import { AssuntoMensagem } from "core/features/mensagens/typings";
import useTotalDashboard from "core/features/unidades/dashboard/useTotalDashboard";
import CollapsibleListCard from "../CollapsibleListCard";
import { useMensagemModal } from "ui/components/DrawerNovaMensagem/MensagemModalContext";
import { TipoDestinoEnum } from "core/features/documentos/enums";
import useMensagensRecebidaUnidade from "core/features/mensagens/hooks/useMensagensRecebidasUnidade";
import CardMensagem from "../CardMensagem";

function CardMensagens({ unidadeId }: { unidadeId: string }) {
  const { openWithDefaultValues } = useMensagemModal();

  const { data, isLoading } = useTotalDashboard(
    `/v1/unidades/dashboard/${unidadeId}/total-mensagens`
  );

  return (
    <CollapsibleListCard
      isLoading={isLoading}
      unidadeId={unidadeId}
      value={data?.total ?? 0}
      singularTitleText="mensagem(ns) recebida"
      getDataHook={useMensagensRecebidaUnidade}
      newEntryButtonText="Nova mensagem"
      newEntryButtonOnClick={() => {
        openWithDefaultValues({
          assuntoId: AssuntoMensagem.Outros,
          destinos: [
            {
              destinoId: unidadeId,
              tipoDestinoId: TipoDestinoEnum.UmaUnidade,
              label: "Essa unidade",
            },
          ],
          tipoDestinoId: TipoDestinoEnum.UmaUnidade,
        });
      }}
      ContentItem={({ item }) => (
        <CardMensagem mensagem={item} unidadeId={unidadeId} />
      )}
    />
  );
}

export default CardMensagens;
